module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "more-projects"
  }, [_c('h4', {
    staticClass: "title"
  }, [_vm._v("More " + _vm._s(_vm.categories))]), _vm._v(" "), _c('div', {
    staticClass: "projects-container"
  }, _vm._l((_vm.projects), function(project) {
    return _c('div', {
      key: project.id,
      staticClass: "project-item"
    }, [_c('project-banner', {
      attrs: {
        "project": project
      }
    })], 1)
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac605a9e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MoreProjects.vue
// module id = 118
// module chunks = 0